import React from "react";
import styled from "styled-components";

export const SlantedSection: React.FC<{
  offset: number;
  height: number;
  width: number;
  justifyContent: string;
  alignItems?: string;
  secondaryGradient?: boolean;
  children?: React.ReactNode;
}> = (props) => (
  <Wrapper>
    <SlantedRectangle
      offset={props.offset}
      height={props.height}
      width={props.width}
    >
      <Background />
      <Content
        justifyContent={props.justifyContent}
        alignItems={props.alignItems}
      >
        {props.children}
      </Content>
    </SlantedRectangle>
  </Wrapper>
);

const Wrapper = styled.div`
  z-index: 1;
  display: flex;
  justify-content: center;
  height: 100%;
  width: 120%;
  margin: auto;
  overflow: visible;
`;

const SlantedRectangle = styled.div<{
  offset: number;
  height: number;
  width: number;
}>`
  position: relative;

  margin-left: ${(props) => (props.offset < 0 ? props.offset * 2 : 0)}px;
  margin-right: ${(props) => (props.offset > 0 ? -props.offset * 2 : 0)}px;
  height: ${(props) => props.height}px;
  width: ${(props) => props.width}px;

  padding: 0;
`;

const Background = styled.div`
  transform: skew(-30deg);
  background: white;
  width: 100%;
  height: 100%;
`;

const Content = styled.div<{
  justifyContent: string;
  alignItems?: string;
}>`
  position: absolute;
  top: 0;
  display: flex;
  justify-content: ${(props) => props.justifyContent};
  ${(props) =>
    props.alignItems !== undefined &&
    `
    align-items: ${props.alignItems};
  `}
  width: 100%;
  height: 100%;
`;
